// extracted by mini-css-extract-plugin
export default {"bp-small":"768px","menus":"Menus-loader-module__menus___L77zZ","fake":"Menus-loader-module__fake___CYtGu","fakeItem":"Menus-loader-module__fakeItem___zoCGU"};